/*
 * Grippatch - koruma teknolojisi bilgi sayfalari (Liquid PPF / Hibrit)
 *
 * Uc davranis var, ucu de ILERIYE DONUK GELISTIRME: bu dosya hic yuklenmese
 * de sayfa eksiksiz okunur.
 *   - katman kesiti  : betik yokken ilk katman secili basiliyor, metni dolu
 *   - bolum indeksi  : betik yokken normal ic baglanti listesi
 *   - kiyas tablosu  : betik yokken telefonda yatay kayan TAM tablo
 *
 * Beliris animasyonu KALDIRILDI (2026-08-25 ikinci tur). Sebep iki katli:
 * kurumsal bir teknik foyde hareket yok, ve "once gizle sonra JS ile goster"
 * kalibi betik yuklenmedigi anda sayfanin yarisini gorunmez birakiyordu.
 */

(function () {
  'use strict';

  /* ------------------------------------------------- 1) katman kesiti */

  function katmanKur(kok) {
    var modul = kok.querySelector('[data-pp-katman]');
    if (!modul) return;

    var secler = modul.querySelectorAll('[data-pp-sec]');
    var katmanlar = modul.querySelectorAll('[data-pp-slab]');
    var numaralar = modul.querySelectorAll('[data-pp-olcu]');
    var panelAd = modul.querySelector('[data-pp-panel-ad]');
    var panelMetin = modul.querySelector('[data-pp-panel-metin]');
    if (!secler.length) return;

    function goster(i) {
      Array.prototype.forEach.call(secler, function (s, n) {
        var aktif = n === i;
        s.setAttribute('aria-selected', aktif ? 'true' : 'false');
        s.setAttribute('tabindex', aktif ? '0' : '-1');
      });
      Array.prototype.forEach.call(katmanlar, function (s, n) {
        s.classList.toggle('is-aktif', n === i);
      });
      Array.prototype.forEach.call(numaralar, function (s, n) {
        s.classList.toggle('is-aktif', n === i);
      });

      var kaynak = secler[i];
      /* Vurgu rengi katmanin TURUNDEN geliyor: eklenen koruma katmanlari
         vurgu rengini alir, mevcut yuzey katmanlari almaz. Renk modul kokune
         yaziliyor; secici, cizim ve panel ayni degeri paylasiyor. */
      modul.style.setProperty('--pp-vurgu', kaynak.getAttribute('data-pp-renk') || 'var(--accent-ink)');
      if (panelAd) panelAd.textContent = kaynak.getAttribute('data-pp-ad') || '';
      if (panelMetin) panelMetin.textContent = kaynak.getAttribute('data-pp-metin') || '';
    }

    Array.prototype.forEach.call(secler, function (s, i) {
      s.addEventListener('click', function () { goster(i); });

      /* Sekme kalibi: ok tuslariyla gezilir, Home/End uclara gider. */
      s.addEventListener('keydown', function (e) {
        var y = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') y = (i + 1) % secler.length;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') y = (i - 1 + secler.length) % secler.length;
        if (e.key === 'Home') y = 0;
        if (e.key === 'End') y = secler.length - 1;
        if (y === null) return;
        e.preventDefault();
        goster(y);
        secler[y].focus();
      });
    });

    /* Cizimdeki katmanlar erisilebilirlik agacinda yok (`aria-hidden`);
       yalnizca fare kullanicisi icin kisayol - secimi sekmeye tasiyorlar. */
    Array.prototype.forEach.call(katmanlar, function (s, i) {
      s.addEventListener('click', function () { goster(i); });
    });

    goster(0);
  }

  /* ------------------------------------------------- 2) bolum indeksi */

  function indeksKur(kok) {
    var indeks = kok.querySelector('[data-pp-indeks]');
    if (!indeks) return;

    var linkler = indeks.querySelectorAll('[data-pp-hedef]');
    if (!linkler.length || !('IntersectionObserver' in window)) return;

    var hedefler = [];
    Array.prototype.forEach.call(linkler, function (l) {
      var h = document.getElementById(l.getAttribute('data-pp-hedef'));
      if (h) hedefler.push({ link: l, bolum: h });
    });
    if (!hedefler.length) return;

    function isaretle(bolum) {
      hedefler.forEach(function (h) {
        h.link.classList.toggle('is-aktif', h.bolum === bolum);
      });
    }

    /* Ust sinir YAPISKAN BASLIK kadar asagi cekiliyor - header'in altinda
       kalan bolum "okunuyor" sayilmasin. Yukseklik theme.js'in yazdigi
       `--header-h` degiskeninden okunuyor; sabit sayi yazsak baslik
       yuksekligi degistiginde sessizce kayardi. */
    var basSt = getComputedStyle(document.documentElement).getPropertyValue('--header-h');
    var bas = parseInt(basSt, 10);
    if (!bas || bas < 40) bas = 78;

    var g = new IntersectionObserver(
      function (girisler) {
        var gorunen = girisler.filter(function (x) { return x.isIntersecting; });
        if (!gorunen.length) return;
        gorunen.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
        isaretle(gorunen[0].target);
      },
      { rootMargin: '-' + (bas + 18) + 'px 0px -62% 0px', threshold: 0 }
    );

    hedefler.forEach(function (h) { g.observe(h.bolum); });
    isaretle(hedefler[0].bolum);
  }

  /* ------------------------------------------------- 3) kiyas tablosu */

  function kiyasKur(kok) {
    var sar = kok.querySelector('[data-pp-kiyas]');
    if (!sar) return;

    var tablo = sar.querySelector('table');
    var dugmeler = sar.querySelectorAll('[data-pp-sut]');
    if (!tablo || !dugmeler.length) return;

    /* Sinif JS ile ekleniyor: betik calismazsa tablo hicbir sutunu gizlemez. */
    tablo.classList.add('is-tekli');

    function ac(i) {
      Array.prototype.forEach.call(dugmeler, function (d, n) {
        d.setAttribute('aria-pressed', n === i ? 'true' : 'false');
      });
      Array.prototype.forEach.call(tablo.querySelectorAll('.ppfc__sut'), function (h) {
        h.classList.toggle('is-acik', parseInt(h.getAttribute('data-sut-no'), 10) === i);
      });
    }

    Array.prototype.forEach.call(dugmeler, function (d, i) {
      d.addEventListener('click', function () { ac(i); });
    });

    ac(0);
  }

  /* ---------------------------------------------------------- kurulum */

  function basla() {
    var kok = document.querySelector('[data-ppf]');
    if (!kok) return;
    katmanKur(kok);
    indeksKur(kok);
    kiyasKur(kok);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', basla);
  } else {
    basla();
  }

  /* Tema duzenleyicide bolum yeniden basilinca kurulum tekrarlanir. */
  document.addEventListener('shopify:section:load', basla);
})();
